import { useQuery } from '@tanstack/react-query';
import { Query } from '../api';

export interface Datastore {
  id: string;
  name: string;
  type_name: string;
  enabled: boolean;
  config?: Record<string, any>;
}

interface DatastoreListResponse {
  data: Array<{
    id: string;
    type: string;
    attributes: {
      name: string;
      type_name: string;
      enabled: boolean;
      config?: Record<string, any>;
      created_at: string;
      updated_at: string;
    };
  }>;
}

function extractDatastoreListData(response: any): Datastore[] {
  // The Query class flattens JSON:API responses, so attributes are at root level
  return response.data.map((item: any) => ({
    id: item.id,
    name: item.name || item.attributes?.name,
    type_name: item.type_name || item.attributes?.type_name,
    enabled:
      item.enabled !== undefined ? item.enabled : item.attributes?.enabled,
    config: item.config || item.attributes?.config,
  }));
}

export const datastoreKeys = {
  all: ['datastores'] as const,
  lists: () => [...datastoreKeys.all, 'list'] as const,
  list: (accountId: string) => [...datastoreKeys.lists(), accountId] as const,
};

/**
 * Hook to fetch all datastores for an account
 */
export function useDatastores(accountId: string, enabledOnly: boolean = true) {
  return useQuery({
    queryKey: datastoreKeys.list(accountId),
    queryFn: async () => {
      const query = new Query(`/accounts/${accountId}/datastores`);
      const response = await query.run();

      console.log('📦 Datastores API Response:', response);

      if (!response) {
        return [];
      }

      const datastores = extractDatastoreListData(
        response as DatastoreListResponse,
      );
      console.log('📦 Extracted datastores:', datastores);
      console.log(
        '📦 Enabled only?',
        enabledOnly,
        'Filtered:',
        datastores.filter((d) => d.enabled),
      );

      // Filter to enabled datastores only if requested
      return enabledOnly ? datastores.filter((d) => d.enabled) : datastores;
    },
    enabled: !!accountId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
